const KeenSlider = window.KeenSlider
const { getElement } = window.BAO.utils
const { useDots, useAutoplay } = window.BAO.Carousel.plugins

class SectionHero extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slides', 'slide']
  }

  connectedCallback () {
    super.connectedCallback()

    if (this.els.slide?.elements?.length < 2) return

    this.handleVideoMetaData = this.handleVideoMetaData.bind(this)
    this.handleVideoEnded = this.handleVideoEnded.bind(this)

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    this.onSlideChanged = this.onSlideChanged.bind(this)

    const autoplayDuration = window.matchMedia('(max-width: 767px)').matches
      ? Number(this.dataset.autoplayMobileDuration)
      : Number(this.dataset.autoplayDesktopDuration)

    const instance = new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        mode: 'snap',
        renderMode: 'custom',
        slideChanged: this.onSlideChanged,
      },
      [
        useDots(this.els?.dot?.elements),
        useAutoplay(autoplayDuration, {
          pauseOnHover: true,
          pauseOnVideoPlay: true,
        }),
      ],
    )

    this.handleVideo(instance)

    return instance
  }

  onSlideChanged (instance) {
    const currentSlide = instance.track.details.rel

    this.handleVideo(instance)

    this.els.slide.elements.forEach((slide, index) => {
      slide.setAttribute('aria-hidden', index !== currentSlide)
    })
  }

  handleVideo (instance) {
    const currentSlide = instance?.track?.details?.rel
    if (currentSlide === null) return
    const currentSlideEl = getElement(`[data-slide="${currentSlide}"]`, {
      context: this,
    })

    if (window.matchMedia('(max-width: 767px)').matches) {
      if (currentSlideEl?.dataset?.mobileHasVideo === 'true') {
        const mobileVideoEl = getElement(this.els?.video?.selector, {
          context: currentSlideEl,
        })

        mobileVideoEl.pause()
        mobileVideoEl.currentTime = 0

        mobileVideoEl.removeEventListener('play', this.handleVideoMetaData)
        mobileVideoEl.addEventListener('play', this.handleVideoMetaData)

        mobileVideoEl.removeEventListener('ended', this.handleVideoEnded)
        mobileVideoEl.addEventListener('ended', this.handleVideoEnded)

        mobileVideoEl.play()
      }
    } else {
      if (currentSlideEl?.dataset?.desktopHasVideo === 'true') {
        const desktopVideoEl = getElement(this.els?.video?.selector, {
          context: currentSlideEl,
        })

        desktopVideoEl.pause()
        desktopVideoEl.currentTime = 0

        desktopVideoEl.removeEventListener('play', this.handleVideoMetaData)
        desktopVideoEl.addEventListener('play', this.handleVideoMetaData)

        desktopVideoEl.removeEventListener('ended', this.handleVideoEnded)
        desktopVideoEl.addEventListener('ended', this.handleVideoEnded)

        desktopVideoEl.play()
      }
    }
  }

  handleVideoMetaData (event) {
    const videoEl = event.target

    videoEl.dispatchEvent(
      new CustomEvent('VIDEO_START', {
        detail: {
          videoEl,
        },
        bubbles: true,
      }),
    )
  }

  handleVideoEnded (event) {
    this.carousel.next()
    const videoEl = event.target

    videoEl.dispatchEvent(
      new CustomEvent('VIDEO_END', {
        detail: {
          videoEl,
        },
        bubbles: true,
      }),
    )
  }
}

if (!customElements.get('section-hero')) {
  customElements.define('section-hero', SectionHero)
}
